import React from "react";

/**
 * Heetch Pro grouped list — dark surface, muted row separators.
 */
export function GroupedList({ title, children, className = "" }) {
  return (
    <div className={className}>
      {title && (
        <div className="px-1 pb-2 hp-label">
          {title}
        </div>
      )}
      <div className="bg-[var(--surface)] border border-[var(--border)] rounded-xl divide-y divide-[var(--border-soft)] overflow-hidden">
        {children}
      </div>
    </div>
  );
}

export function GroupedListRow({
  icon: Icon,
  label,
  sublabel,
  right,
  onClick,
  testId,
  danger = false,
  as: Tag = "button",
  href,
  iconColor: _iconColor,
}) {
  const content = (
    <>
      {Icon && (
        <div className={`w-9 h-9 rounded-lg grid place-items-center shrink-0 border ${
          danger
            ? "border-rose-500/40 text-rose-400 bg-rose-500/10"
            : "border-[var(--border)] text-zinc-300 bg-[var(--surface-alt)]"
        }`}>
          <Icon className="w-4 h-4" strokeWidth={1.8} />
        </div>
      )}
      <div className="flex-1 min-w-0 text-left">
        <div className={`text-[14px] font-medium truncate ${danger ? "text-rose-400" : "text-[var(--text)]"}`}>
          {label}
        </div>
        {sublabel && (
          <div className="text-xs text-zinc-500 truncate mt-0.5">{sublabel}</div>
        )}
      </div>
      {right !== undefined ? (
        <div className="text-zinc-500 shrink-0">{right}</div>
      ) : (
        <svg className="w-4 h-4 text-zinc-600 shrink-0" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
          <polyline points="9 18 15 12 9 6" />
        </svg>
      )}
    </>
  );
  const cls = "flex items-center gap-3 w-full px-4 py-3.5 hover:bg-[var(--surface-alt)]/60 active:bg-[var(--surface-alt)] transition-colors";
  if (Tag === "a" || href) {
    return (
      <a href={href} onClick={onClick} data-testid={testId} className={cls}>
        {content}
      </a>
    );
  }
  return (
    <button type="button" onClick={onClick} data-testid={testId} className={cls}>
      {content}
    </button>
  );
}
